import { render, staticRenderFns } from "./leaderTodo.vue?vue&type=template&id=80e2e388&scoped=true&"
import script from "./leaderTodo.vue?vue&type=script&lang=js&"
export * from "./leaderTodo.vue?vue&type=script&lang=js&"
import style0 from "./leaderTodo.vue?vue&type=style&index=0&id=80e2e388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e2e388",
  null
  
)

export default component.exports